/**
 * @typedef {Object} StatusCodeHandlers
 * @prop {number} statusCode
 * @prop {StatusCodeHandler} handler
 */

import { MetaforceContext } from '../contexts'

/**
 * @param {*} apiError 
 * @param {StatusCodeHandlers[]} statusCodeHandlers 
 */

export const apiErrorHandler = async (apiError, statusCodeHandlers = null) => {
  if (!apiError.response) { // if the api didn't respond, then the regular axios error response will not be set
    throw apiError
  }
  const { status, data } = apiError.response;
  const statusCodeHandler = statusCodeHandlers?.find(s => s.statusCode === status)
  if (statusCodeHandler) {
    await statusCodeHandler.handler(data);
    
    if (statusCodeHandler.cancelThrow) {
      return;
    }
  }
  else {
    if (status === 400) {
      if (data.Message === 'Unable to save record. Record has been modified by another user.') {
        apiError.customErrorMessage = data.Message;
      }
      else if (data.ValidationErrors) {
        apiError.validationErrors = Object.keys(data.ValidationErrors).map((key) => {
          return {
            key,
            errors: data.ValidationErrors[key],
          }
        })
      }
    }
  }
  throw apiError
}